import Immutable from "immutable";

const settingsTeamState = Immutable.Map({
  newUserName: "",
  newUserEmail: "",
  newUserRole: ""
});

export const settingsTeam = (state = settingsTeamState, action) => {
  switch (action.type) {
    case "SET_SETTINGS_TEAM":
      return state.merge(action.payload);
    default:
      return state;
  }
};
